export { DocumentsPageComponent } from './documents-page.component';
